import { View, VideoView, VideoControlBarView } from "@gaming/srvg-classes-core";
import { OverlayContainerContainerView } from "./OverlayContainerContainerView";

/**
 * Main view class for the VFC cup view.
 */
export class VideoAreaView extends View {
    videoView:VideoView;
    videoControlBar:VideoControlBarView;
    overlayContainerContainerView: OverlayContainerContainerView;

    constructor(options) {
        options = options || {};
        super(options);
        //this.isExpanded = true;

        var hdChannel = null;
        if (srvg.videooptions.alt_videobasename) {
            if (!srvg.featuresInstances.getStartWithHd()) {
                hdChannel = srvg.videooptions.serverurl + srvg.videooptions.videobasename;
            }
            else {
                hdChannel = srvg.videooptions.serverurl + srvg.videooptions.alt_videobasename;
            }
        }

        // Setting the videoHandlers order for the videoView
        var videoHandlers = [];
        if (srvg.Player.getWorkingStreamType() == 'flash') {
            videoHandlers = ['flash', 'hls', 'html5'];
        } else {
            if(srvg.featuresInstances.getFlashVideoByDefault() === false)
                videoHandlers = ['hls', 'flash', 'html5'];
        }


        var myAllowFullscreen =  srvg.featuresInstances.getDisableFullscreen() ? false : true;
        var myMuted =  srvg.featuresInstances.getDisableAudioByDefault() || srvg.videooptions.startMute ? true : false;
        var mySrc = srvg.videooptions.alt_videobasename && !srvg.featuresInstances.getStartWithHd()
            ? srvg.videooptions.serverurl + srvg.videooptions.alt_videobasename + srvg.videooptions.defaultchannel
            : srvg.videooptions.serverurl + srvg.videooptions.videobasename + srvg.videooptions.defaultchannel;


        if(srvg.videoplayer.type === 'liveplayer' && srvg.flostCheck.isFlost === false) {
            this.videoView = this.addSubView(new VideoView({
                selector: '#videoView',
                playerOptions: {
                    hdChannel: hdChannel,
                    hdswitch: null,
                    overlays: '#overlay',
                    useLiveplayer: true,
                    hidePlayButton: false,
                    hideStopButton: true,
                    hide: 'display',
                    muted: myMuted,
                    vod: false,
                    loglevel: 0,
                    ui: {
                        enabled: true,
                        videoControls: false,
                        fullscreen: false,
                        controlBarHideDelay: 3
                    },
                    poster: srvg.url.image + 'video/poster.png',
                    noButton: false,
                    autoplay: true,
                    swf: srvg.url.webroot + 'liveplayer/srplayer.swf',
                    videoHandlers: videoHandlers,
                    smoothTransition: false
                }


            },srvg));
        }


        if(navigator.userAgent.indexOf('Safari') > 0 && navigator.userAgent.indexOf('Chrome') < 0){

            myMuted = true;
            srvg.videoplayer.forceMuted = true;
        }
        // console.log('Muted', myMuted, (srvg.featuresInstances.getDisableAudioByDefault() || srvg.videooptions.startMute));

        if(srvg.videoplayer.type === 'flowplayer' && srvg.flostCheck.isFlost === false) {
            this.videoView = this.addSubView(new VideoView({
                selector: '#videoView',
                playerOptions: {
                    hdChannel: hdChannel,
                    useLiveplayer: false,
                    debug: false,   // remove this when in production
                    autoplay: false,
                    disabled: true,  // disable gui elements, player.js hides
                    volume: 1.0,
                    poster: srvg.url.image + 'video/poster.png',
                    muted: myMuted,
                    fullscreen: myAllowFullscreen,
                    bgcolor: '#000',  // nur für flash
                    clip: {
                        sources: [
                            {

                                type: srvg.featuresInstances.getFlashVideoByDefault() ? "video/flv" : "application/x-mpegURL",
                                src: mySrc
                            },
                        ],
                        live: true,
                    }
                }
            },srvg));
        }

        this.videoControlBar = this.addSubView(new VideoControlBarView({selector: '#videoControlbar'}));

        this.videoControlBar.playpauseButton.$domNode.addClass('enabled');
        if (srvg.videooptions.alt_videobasename) {
            this.videoControlBar.hdButton.$domNode.addClass('enabled');
            if (!srvg.featuresInstances.getStartWithHd()) {
                this.videoControlBar.hdButton.$domNode.addClass('pressed');
            }
        }
        this.videoControlBar.soundButton.$domNode.addClass('enabled');
        if (
            srvg.featuresInstances.getDisableAudioByDefault()
            || srvg.videooptions.startMute
            || srvg.videoplayer.forceMuted == true
            || (localStorage.getItem('livePlayerVolume') == "0" && srvg.videoplayer.type == 'liveplayer') // Liveplayer sound setting
            || (localStorage.getItem('muted') == "true" && srvg.videoplayer.type == 'flowplayer')       // Flowplayer sound setting
        )
        {
            this.videoControlBar.soundButton.$domNode.addClass('pressed');
        }

        this.overlayContainerContainerView = this.addSubView( new OverlayContainerContainerView( {} ) );


    }


}
